export default function getBody(
  format: 'Html' | 'Text',
  options?: { hostConfig?: boolean },
): Promise<string> {
  return new Promise((resolve) => {
    const item = Office.context.mailbox?.item;
    if (!item) return resolve('');

    const coercionType =
      format === 'Html' ? Office.CoercionType.Html : Office.CoercionType.Text;
    const resolveValue = (result: Office.AsyncResult<string>) =>
      resolve((result.value as string) ?? '');

    if (options?.hostConfig) {
      item.body.getAsync(
        coercionType,
        { bodyMode: Office.MailboxEnums.BodyMode.HostConfig },
        resolveValue,
      );

      return;
    }

    item.body.getAsync(coercionType, resolveValue);
  });
}
